import React from 'react';
import PortfolioView from '../MyWork/index.jsx';

/**
 * Portfolio Findings page — every client the rep owns, with their Findings
 * (challenges + nested ProposedSolutions) surfaced for triage. Sits in the
 * sidebar alongside Actionables (the committed-work surface).
 *
 * Implemented as a thin wrapper over the shared PortfolioView with kind locked
 * to 'findings'. The shared component handles fetching, grouping, filtering,
 * inline edit, chat, etc.
 */
const Findings = () => <PortfolioView kind='findings' />;

export default Findings;
